import { useMemo } from 'react';
import { useSelector } from "react-redux";
import { canEditWorklog, canEditWorklogCrewAndTime, canEditWorkerCrewLeader } from 'common/permissions/can-edit-worklog';

/**
 * @param {Worklog|Sheet} sheet
 * @returns {boolean}
 */
export const useCanEditWorklog = (sheet) => {
  const { user, organizationLocation } = useSelector(state => state.personalProfile || {});
  const { showAllLocations } = useSelector(state => state.schedule);
  const settings = organizationLocation?.settings;

  return useMemo(() => {
    if (!user || !settings || !sheet?._id || showAllLocations) return false;

    return canEditWorklog(sheet, user, settings)
  }, [user, settings, showAllLocations, sheet])
}

/**
 * @param {Worklog|Sheet} sheet
 * @returns {boolean}
 */
export const useCanEditWorklogCrewAndTime = (sheet) => {
  const { user, organizationLocation } = useSelector(state => state.personalProfile || {});
  const { showAllLocations } = useSelector(state => state.schedule);
  const settings = organizationLocation?.settings;

  return useMemo(() => {
    if (!user || !settings || !sheet?._id || showAllLocations) return false;

    return canEditWorklogCrewAndTime(sheet, user, settings)
  }, [user, settings, showAllLocations, sheet])
}

/**
 * @param {Worklog|Sheet} sheet
 * @returns {(worker: object) => boolean} predicate for a worker's CL toggle
 */
export const useCanEditWorklogCrewLeader = (sheet) => {
  const { user, organizationLocation } = useSelector(state => state.personalProfile || {});
  const { showAllLocations } = useSelector(state => state.schedule);
  const settings = organizationLocation?.settings;

  return useMemo(() => {
    if (!user || !settings || !sheet?._id || showAllLocations) return () => false;

    return (worker) => canEditWorkerCrewLeader(sheet, user, worker, settings)
  }, [user, settings, showAllLocations, sheet])
}